// extracted by mini-css-extract-plugin
export default {"markdown-with-components":"styles__markdown-with-components---9IJM","component-segment":"styles__component-segment--OQKoc"};